import React, {memo} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Styles */
import s from './hb-placeholder-frame.scss'

const MAX_WIDTH = 100;

const HbPlaceholderFrame = memo(({
  className,
  contentClassName,
  children,
  ratio,
}) => {
  let placeholderStyles = {};
  if (ratio) {
    placeholderStyles = {
      paddingTop: `${MAX_WIDTH / ratio}%`,
    };
  }

  return (
    <div className={cx(
      s.root,
      className,
      'hb-Placeholder-frame',
      {
        [s.hasRatio]: Boolean(ratio),
      }
    )}>
      <div
        className={s.placeholder}
        style={placeholderStyles}/>
      <div className={cx(s.content, contentClassName)}>
        {children}
      </div>
    </div>
  );
});

HbPlaceholderFrame.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  ratio: PropTypes.number,
}

export default HbPlaceholderFrame
